/**
 * Model used to hold a model along with an isSelected property
 * so it can be tracked when displaying in a checkbox list.
 *
 * Example: Features checkbox list on the basics component
 */
export class SelectableItem {
    public model: any;
    public isSelected: boolean;
    public isEnabled: boolean;

    constructor(model: any, isSelected: boolean, isEnabled?: boolean) {
        this.model = model;
        this.isSelected = isSelected;
        // Default isEnabled to true
        this.isEnabled = typeof isEnabled === 'undefined' ? true : isEnabled;
    }
}
